export default __webpack_public_path__ + "81229f94c7f6be3e0ed742862c6e479d.png";